/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiProjectstatusesIdMutationRequest,
  PutApiProjectstatusesIdMutationResponse,
  PutApiProjectstatusesIdPathParams,
} from '../models/PutApiProjectstatusesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiProjectstatusesIdMutationResponseSchema,
  putApiProjectstatusesIdMutationRequestSchema,
} from '../zod/putApiProjectstatusesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiProjectstatusesIdMutationKey = () =>
  [{ url: '/api/projectstatuses/:id' }] as const;

export type PutApiProjectstatusesIdMutationKey = ReturnType<
  typeof putApiProjectstatusesIdMutationKey
>;

/**
 * {@link /api/projectstatuses/:id}
 */
export async function putApiProjectstatusesId(
  id: PutApiProjectstatusesIdPathParams['id'],
  data: PutApiProjectstatusesIdMutationRequest,
  config: Partial<RequestConfig<PutApiProjectstatusesIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiProjectstatusesIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiProjectstatusesIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiProjectstatusesIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/projectstatuses/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiProjectstatusesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectstatuses/:id}
 */
export function usePutApiProjectstatusesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiProjectstatusesIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiProjectstatusesIdPathParams['id'];
        data: PutApiProjectstatusesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiProjectstatusesIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiProjectstatusesIdMutationKey();

  return useMutation<
    PutApiProjectstatusesIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiProjectstatusesIdPathParams['id'];
      data: PutApiProjectstatusesIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiProjectstatusesId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
